module.exports = __webpack_public_path__ + "assets/mstile-310x310.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/mstile-310x310.png
// module id = 937
// module chunks = 17